var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.page_footer,attrs:{"id":"PageFooter"}},[_vm._v("\n  "+_vm._s(_vm.copyright)),_c('br'),_vm._v("\n  made by: "+_vm._s(_vm.author)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-502494f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/PageFooter.vue
// module id = null
// module chunks = 